import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';

import type { MultiButtonComponentProps } from 'app/main/components/buttons/MultiButton';
import useSettings from 'app/main/components/hooks/useSettings';
import Icon from 'app/main/components/Icon';
import ViewPagination, { type ViewPaginationProps } from '../pagination/ViewPagination';

export interface NoRowsOverlayProps {
	message?: string;
}

export type ViewTableToolbarProps = {
	hasHiddenColumns: boolean;
	showColumnVisibilityDialog: () => void;
} & Omit<ViewPaginationProps, 'additionalButtons' | 'showOrder'>;

function LoadingOverlay() {
	return <LinearProgress variant="query" />;
}

function NoRowsOverlay({ message }: NoRowsOverlayProps) {
	const { t } = useSettings();

	return (
		<Box className="flex h-full flex-col items-center justify-center">
			<Typography className="italic" color="textSecondary">
				{t(message || 'LIST_NO_ITEMS')}
			</Typography>
		</Box>
	);
}

function ViewTableToolbar({ hasHiddenColumns, showColumnVisibilityDialog, ...otherProps }: ViewTableToolbarProps) {
	return (
		<ViewPagination
			{...otherProps}
			additionalButtons={[
				{
					title: 'VIEW_TABLE_BUTTON_COLUMN_VISIBILITY',
					icon: 'view-column',
					onClick: showColumnVisibilityDialog,
					showBadge: hasHiddenColumns
				}
			]}
			showOrder={false}
		/>
	);
}

function ViewTableRowActionsMenuComponent({ anchorRef, onClick }: MultiButtonComponentProps) {
	const { t } = useSettings();

	return (
		<GridActionsCellItem
			ref={anchorRef}
			label={t('VIEW_ITEM_BUTTON_MORE')}
			icon={<Icon icon="dots-vertical" />}
			onClick={onClick}
		/>
	);
}

export { LoadingOverlay, NoRowsOverlay, ViewTableRowActionsMenuComponent, ViewTableToolbar };
